import { Component, OnInit, inject } from '@angular/core';
import { LimitOffsetPaging } from '../../../core/models/paged-results/limit-offset-paging.model';
import { ClientConsultNoteTask } from '../../../core/models/client-consult-note-task.model';
import {
  ClientConsultNoteTasksService,
  PagedClientConsultNoteTasks,
} from '../../../core/services/client-consult-note-tasks.service';
import { TaskFilters, TaskQueueSettings } from 'app/core/models/user-settings/task-settings.model';
import { ClientConsultNoteTaskStatus } from 'app/core/enums/client-consult-note-task-status.enum';
import { ClientsService } from 'app/core/services/clients.service';
import { UserSettingsService } from 'app/core/services/user-settings.service';
import { UserSettings } from 'app/core/enums/user-settings.enum';
import { displayTaskStatus } from 'app/core/options/task-status.opts';
import { ClientTasksFilterComponent } from '../../../shared/components/client-tasks-filter/client-tasks-filter.component';

import { ClientConsultNoteTaskListComponent } from '../../components/client-consult-note-task-list/client-consult-note-task-list.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-capture-admin-client-consult-note-tasks',
    templateUrl: './capture-admin-client-consult-note-tasks.component.html',
    styleUrls: ['./capture-admin-client-consult-note-tasks.component.scss'],
    imports: [ClientTasksFilterComponent, ClientConsultNoteTaskListComponent, MatProgressSpinner]
})
export class CaptureAdminClientConsultNoteTasksComponent implements OnInit {
  private clientConsultNoteTasksService = inject(ClientConsultNoteTasksService);
  private userSettingsService = inject(UserSettingsService);
  private clientsService = inject(ClientsService);

  tasks: ClientConsultNoteTask[] = [];
  paging: LimitOffsetPaging;

  filters: TaskFilters = new TaskFilters();
  taskStatuses = [];
  specialties = [];
  manufacturers = [];
  sources = [];
  clients = [];

  loading = true;
  exportUrl = null;

  ngOnInit() {
    this.init();
  }

  filtersChange(filters) {
    this.filters = filters;
    this.loadTasks(1);
    this.saveQueueSettings();
  }

  onPageSizeChange(size) {
    this.paging.pageSize = size;
    this.loadTasks(this.paging.currentPage);
  }

  onPageChange(page) {
    this.loadTasks(page);
  }

  private init() {
    this.paging = LimitOffsetPaging.empty;
    this.loadQueueSettings();

    this.loadStatuses();
    this.loadSpecialties();
    this.loadManufacturers();
    this.loadSources();
    this.loadClients();

    this.loadTasks(1);
  }

  private loadStatuses() {
    this.taskStatuses = Object.values(ClientConsultNoteTaskStatus).map(v => ({
      value: v,
      display: displayTaskStatus(v),
    }));
  }

  private loadSpecialties() {
    this.clientsService.getSpecialties().subscribe(result => {
      this.specialties = result;
    });
  }

  private loadManufacturers() {
    this.clientConsultNoteTasksService.getManufacturers().subscribe(result => {
      this.manufacturers = result;
    });
  }

  private loadSources() {
    this.clientConsultNoteTasksService.getSources().subscribe(result => {
      this.sources = result;
    });
  }

  private loadClients() {
    this.clientsService.getList(null, { applicableToReferralClaims: true }).subscribe(result => {
      this.clients = result.clients;
    });
  }

  private loadTasks(page) {
    this.loading = true;
    const paging = { page, pageSize: this.paging.pageSize };

    this.clientConsultNoteTasksService.getList(paging, this.filters).subscribe(
      (result: PagedClientConsultNoteTasks) => {
        this.tasks = result.clientConsultNoteTasks;
        this.paging = result.meta.paging;
        this.loading = false;
      }
    );
  }

  private loadQueueSettings() {
    const queueSettings: TaskQueueSettings = this.userSettingsService.get<TaskQueueSettings>(
      UserSettings.captureAdminConsultNoteTaskQueueSettings
    );

    if (queueSettings) {
      this.paging = queueSettings.paging;
      this.filters = queueSettings.filters;
    }
  }

  private saveQueueSettings(position = null) {
    const queueSettings = new TaskQueueSettings();
    queueSettings.position = position;
    queueSettings.paging = this.paging;
    queueSettings.filters = this.filters;
    this.userSettingsService.save<TaskQueueSettings>(
      UserSettings.captureAdminConsultNoteTaskQueueSettings,
      queueSettings
    );
  }
}
